import { render, staticRenderFns } from "./VTable.vue?vue&type=template&id=02d07088&scoped=true"
import script from "./VTable.vue?vue&type=script&lang=ts"
export * from "./VTable.vue?vue&type=script&lang=ts"
import style0 from "./VTable.vue?vue&type=style&index=0&id=02d07088&prod&lang=scss&scoped=true"
import style1 from "./VTable.vue?vue&type=style&index=1&id=02d07088&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02d07088",
  null
  
)

export default component.exports